import { render } from "./TileRules.vue?vue&type=template&id=206f2684"
import script from "./TileRules.vue?vue&type=script&lang=js"
export * from "./TileRules.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__